<template>
  <div class="container">

    <h1>
      <font-awesome-icon icon="home" /> Home - <a href="#">Wallet</a>

      <div class="float-right">


        <b-button v-b-modal.modal-lg v-b-tooltip.hover title="Help">
          <font-awesome-icon icon="info" />
        </b-button>

        <b-modal id="modal-lg" size="lg" title="Wallet">


          <div class="panal">
            <div>

              <div class="panal-header"> {{ info.PageName ? info.PageName : '' }}</div>
              <div class="panal-body">

                <div v-html="info.PageDescription"></div>
              </div>
            </div>



          </div>

          <div class="panal" v-for="help in info.HelpSection" :key="help.serial">
            <div>

              <div class="panal-header"> {{ help.SectionName }}</div>
              <div class="panal-body">

                <div v-html="help.SectionDescription"></div>
              </div>
            </div>



          </div>







        </b-modal>

      </div>



    </h1>




    <div class="row">

      <div class="col-md-12 mt-3 mb-3">



        <div class="accordion" id="accordionExample">
          <div class="card">
            <div class="card-header" id="headingOne">
              <h2 class="mb-0">
                <button class="btn btn-link text-left" type="button" data-toggle="collapse" data-target="#collapseOne"
                  aria-expanded="true" aria-controls="collapseOne">
                  Paid

                </button>
              </h2>
            </div>

            <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
              <div class="card-body">
                <div class="text-center" v-if="loading">
                  <b-spinner variant="primary" label="Text Centered"></b-spinner>
                </div>
                <div class="row" v-if="PaidApplicantPaymentsList.length != 0 && !loading">
                  <div class="col-sm-4" v-for="Item in PaidApplicantPaymentsList" v-bind:Key="Item.serial">
                    <div class="card">
                      <div class="card-body">
                        <h5 class="card-title">{{ Item.SemesterName }}</h5>
                        <p class="card-text">Value <span class="float-right">{{ Item.Value }}</span></p>
                        <p class="card-text">From <span class="float-right">{{ Item.PaymentDateFrom |
                moment("ll") }}</span></p>
                        <p class="card-text">To <span class="float-right">{{ Item.PaymentDateTo | moment("ll") }}</span>
                        </p>
                        <p class="card-text">Payment Date <span class="float-right">{{ Item.PaymentDate |
                moment("ll") }}</span></p>
                        <p class="card-text">Receipt No <span class="float-right">{{ Item.ReceiptNumber }}</span></p>
                        <p class="card-text">Payment Name <span class="float-right name">{{ Item.PaymentTypeNameEN
                            }}</span>
                        </p>
                        <p class="card-text">Employee Name <span class="float-right">{{ Item.EmployeeNameEN }}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row" v-else-if="!loading">
                  <div class="col-sm-4">
                    <div class="card">
                      <div class="card-body">
                        <h5 class="card-title">Payment Information</h5>
                        No Paymnet Available

                      </div>
                    </div>

                  </div>

                </div>



              </div>
            </div>
          </div>
          <div class="card" v-if="UnPaidApplicantPaymentsList.length != 0">
            <div class="card-header" id="headingTwo">
              <h2 class="mb-0">
                <button class="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse"
                  data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                  Un Paid
                </button>
              </h2>
            </div>
            <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
              <div class="card-body">
                <div class="text-center" v-if="loading">
                  <b-spinner variant="primary" label="Text Centered"></b-spinner>
                </div>
                <div class="row justify-content-md-center" v-if="UnPaidApplicantPaymentsList.length != 0 && !loading">

                  <div class="col-sm-4" v-for="Item in UnPaidApplicantPaymentsList" v-bind:Key="Item.serial">
                    <div class="card " width="350px" >
                      <div class="card-body">
                        <h5 class="card-title">{{ Item.SemesterName }}</h5>
                        <p class="card-text">Value <span class="float-right">{{ Item.Value }}</span></p>
                        <p class="card-text">From <span class="float-right">{{ Item.PaymentDateFrom |
                moment("ll") }}</span></p>
                        <p class="card-text">To <span class="float-right">{{ Item.PaymentDateTo | moment("ll") }}</span>
                        </p>
                        <p class="card-text">Payment Date <span class="float-right"
                            :class="Item.PaymentDate ? '' : 'text-danger'">{{ Item.PaymentDate ? Item.PaymentDate :
                'Pending Payment' }}</span>
                        </p>
                        <p class="card-text">Receipt No <span class="float-right">{{ Item.ReceiptNumber }}</span></p>
                        <p class="card-text">Payment Name <span class="float-right desc">{{ Item.Description }}</span>
                        </p>
                        <p class="card-text">Employee Name <span class="float-right">{{ Item.EmployeeNameEN }}</span>
                        </p>

                      </div>

                    </div>
                    <!-- <div class="col-sm-12 text-center bg-primary text-white p-2 border-rounded"
                    v-if=" Item.FawryAvailability === 'Available'">
                      <label :for=Item.serial><input type="checkbox" :name=Item.serial id="select" :value=Item.serial
                          v-model="SelectedList" @click="checkedAllPayment"> Select All For Payment </label>
                    </div> -->

           
                    <!-- <div v-for="(Item, index) in UnPaidApplicantPaymentsList" :key="Item.serial">
      <div class="col-sm-12 text-center bg-primary text-white p-2 border-rounded"
           v-if="index === 0">
        <label :for="Item.serial">
          <input type="checkbox" :name="Item.serial" id="select" :value="Item.serial"
                 v-model="SelectedList" @click="checkedAllPayment"> Select All For Payment
        </label>
      </div>
    </div> -->





                  </div>

                  <div v-if="UnPaidApplicantPaymentsList.length > 0" class="col-md-4 btn justify-content-md-center text-center ux-auto bg-primary text-white p-2 border-rounded">
      <label :for="UnPaidApplicantPaymentsList[0].serial">
        <input type="checkbox" :name="UnPaidApplicantPaymentsList[0].serial" id="select" :value="UnPaidApplicantPaymentsList[0].serial"
               v-model="SelectedList" @click="checkedAllPayment"> Select All For Payment
      </label>
    </div>

                </div>

                <div class="row" v-else-if="!loading">
                  <div class="col-sm-4">
                    <div class="card">
                      <div class="card-body">
                        <h5 class="card-title">Payment Information</h5>
                        No Payment Available

                      </div>
                    </div>

                  </div>

                </div>

                <div class="row">
                  <div class="col-sm-12">
                    <h2 class="heading">OnLine Payment</h2>
                  </div>
                  <div class="col-sm-6">
                    <div class="card">
                      <div class="card-body">
                        <h5 class="card-title">Bank Masr</h5>
                        <p class="card-text">All your selected payment to bank masr </p>
                        <input type="image" @click="BMPayment" width="150" height="50"
                          src="https://inlegal.eu/wp-content/uploads/2019/05/visa-and-mastercard-logo-26.png"
                          alt="visa payment" />
<div class="text-right">

  <button type="button" class="btn btn-success mr-1" @click="BMPayment">Pay Now
  </button>


</div>

                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12">
                    <h2 class="heading">OffLine Payment</h2>
                  </div>

                  <div class="col-sm-6" hidden>
                    <div class="card">
                      <div class="card-body">
                        <h5 class="card-title"> Fawry Pay</h5>
                        <p class="card-text"> All your selected payments will be sent to Fawry for payment </p>
                        <input type="image" @click="FawryPayment"
                          src="https://www.atfawry.com/ECommercePlugin/resources/images/atfawry-ar-logo.png"
                          alt="Edfa3 Fawry" id="xsrrs" />


                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="card">
                      <div class="card-body">
                        <h5 class="card-title">Bank Misr</h5>
                        <p class="card-text">Account Number <span class="float-right">4330240000014373</span></p>
                        <button type="button" class="btn btn-primary mr-1" @click="$router.push('paymentorder')">Payment
                          Order</button>


                      </div>
                    </div>
                  </div>
                </div>
               


              </div>
            </div>
          </div>
          <!--    <div class="card">
          <div class="card-header" id="headingThree">
              <h2 class="mb-0">
                <button class="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse"
                  data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                  Payment methods
                </button>
              </h2>
            </div> 
            <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordionExample"> -->
          <!-- <div class="card-body">

                <div class="row"> -->
          <!-- <div class="col-sm-6">
                    <div class="card">
                      <div class="card-body">
                        <h5 class="card-title"> Fawry Pay</h5>
                        <p class="card-text"> All your selected payments will be sent to Fawry for payment </p>
                        <input type="image" @click="FawryPayment"
                          src="https://www.atfawry.com/ECommercePlugin/resources/images/atfawry-ar-logo.png"
                          alt="Edfa3 Fawry" id="xsrrs" />


                      </div>
                    </div>
                  </div> -->
          <!-- <div class="col-sm-6">
                    <div class="card">
                      <div class="card-body">
                        <h5 class="card-title">Bank Misr</h5>
                        <p class="card-text">Account Number <span class="float-right">4330240000014373</span></p>
                        <button type="button" class="btn btn-primary mr-1" @click="$router.push('paymentorder')">Payment
                          Order</button>


                      </div>
                    </div>
                  </div> -->
          <!-- <div class="col-sm-4">
                    <div class="card">
                      <div class="card-body">
                        <h5 class="card-title">Bank Masr</h5>
                        <p class="card-text">All your selected payment to bank masr </p>
                        <input type="image" @click="BMPayment" width="150" height="50"
                          src="https://inlegal.eu/wp-content/uploads/2019/05/visa-and-mastercard-logo-26.png"
                          alt="visa payment" />


                      </div>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="card">
                      <div class="card-body">
                        <h5 class="card-title">Meeza Payment</h5>
                        <p class="card-text">All your selected payment to Meeza </p>
                        <input type="image" @click="MizaPayment" width="150" height="50"
                          src="https://upload.wikimedia.org/wikipedia/en/3/37/Meeza_Egyptian_company_logo.png"
                          alt="visa payment" />



                      </div>
                    </div>
                  </div> -->
          <!-- </div>



              </div> -->
        </div>
      </div>

      <!-- <div class="card">
            <div class="card-header" id="headingFour">
              <h2 class="mb-0">
                <button class="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse"
                  data-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                  Payment
                </button>
              </h2>
            </div> 
            <div id="collapseFour" class="collapse" aria-labelledby="headingFour" data-parent="#accordionExample">
              <div class="card-body">

                <div class="row">
                  <div class="col-sm-6">
                    <div class="card">
                      <div class="card-body">
                        <h5 class="card-title"> application fees <span class="float-right">1000 LE</span></h5>
                        <p class="card-text"> You Can selected payment method will be sent for payment </p>
                       <select class="form-control su-border" v-model="selected">
                          <option value="0">Default select</option>
                          <option v-for="option in options" v-bind:value="option.id" v-bind:key="option.id">
                            {{ option.name }}</option>
                         <option value="1" id="1">Fawry</option>
                          <option value="2" id="2">Bank Masr</option>
                          <option value="3" id="3">on Office</option> 

                        </select> 
                        <div id="default">
                          <div v-if="selected === 1" class="mt-3">
                            <input type="image" @click="FawryPayment"
                              src="https://www.atfawry.com/ECommercePlugin/resources/images/atfawry-ar-logo.png"
                              alt="Edfa3 Fawry" id="xsrrs" />


                          </div>
                          <div v-if="selected === 2" class="mt-3">
                            <h1>Start Accepting Payments Online</h1>
                          </div>
                          <div v-if="selected === 3" class="mt-3">
                            <p> Please Go to the University Headquarters</p>
                            <p>- Cairo: Sama Towers - Kattamiyah - Al-Dawri Road</p>
                            <p>- Al-Qantara: University Headquarters</p>
                            <p>- Al-Arish: University Headquarters</p>

                          </div>

                        </div> 
                       <input type="image" @click="FawryPayment"
                          src="https://www.atfawry.com/ECommercePlugin/resources/images/atfawry-ar-logo.png"
                          alt="Edfa3 Fawry" id="xsrrs" /> 


                      </div>
                    </div>
                  </div>
                   <div class="col-sm-6">
                    <div class="card">
                      <div class="card-body">
                        <h5 class="card-title"> Tuition Fee <span class="float-right">7000 LE</span></h5>
                        <p class="card-text"> You Can selected payment method will be sent for payment </p>
                       <select class="form-control su-border">
                          <option value="0">Default select</option>
                          <option value="1" @click="FawryPayment">Fawry</option>
                          <option value="2">Bank Masr</option>
                          <option value="3">on Office</option>

                        </select>
                        <input type="image" @click="FawryPayment"
                          src="https://www.atfawry.com/ECommercePlugin/resources/images/atfawry-ar-logo.png"
                          alt="Edfa3 Fawry" id="xsrrs" /> 


                      </div>
                    </div>
                  </div> -->
      <!-- <div class="col-sm-4">
                    <div class="card">
                      <div class="card-body">
                        <h5 class="card-title">Bank Masr</h5>
                        <p class="card-text">All your selected payment to bank masr </p>
                        <input type="image" @click="BMPayment" width="150" height="50"
                          src="https://inlegal.eu/wp-content/uploads/2019/05/visa-and-mastercard-logo-26.png"
                          alt="visa payment"  />


                      </div>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="card">
                      <div class="card-body">
                        <h5 class="card-title">Meeza Payment</h5>
                        <p class="card-text">All your selected payment to Meeza </p>
                        <input type="image" @click="MizaPayment" width="150" height="50"
                          src="https://upload.wikimedia.org/wikipedia/en/3/37/Meeza_Egyptian_company_logo.png"
                          alt="visa payment"  />
                          


                      </div>
                    </div>
                  </div> 
                </div> 



              </div>
            </div>
          </div>-->


      <!-- 
        </div>

      </div>-->


    </div>




  </div>

</template>

<script>
import axios from 'axios'
import ApplicantDataServices from '../../services/Applicant/ApplicantData.services'
import ApplicantService from '../../services/Applicant/Applicant.service'
import {
  ApplicantPaymentList
} from '../../models/Applicant'
import {
  API_URL
} from '../../services/API_URL'


export default {
  components: {

  },
  data() {
    return {
      selected: 'Choose Option',
      options: [
        { id: 1, name: 'Fawry' },
        { id: 2, name: 'Bank Masr' },
        { id: 3, name: 'on Office' }
      ],
      info: '',
      AllPayment: [],
      PaidApplicantPaymentsList: new ApplicantPaymentList('', '', '', '', '', '', '', '', '', '', '', '', '', '', '',
        '', '', ''),
      UnPaidApplicantPaymentsList: new ApplicantPaymentList('', '', '', '', '', '', '', '', '', '', '', '', '', '',
        '', '', '', ''),
      submitted: false,
      loading: false,
      successful: false,
      message: '',
      SelectedList: [],
      SentPayemtList: [],
      PaymentOrder: [],
      OrderDetails: null,
      showModal: false,
    }
  },
  methods: {



    FawryPayment() {

      this.$store.dispatch('auth/payment', this.selectpayment).then(
        () => {
          localStorage.setItem('payment', JSON.stringify(this.selectpayment));
          this.$router.push('/fawry')
        })

    },
    BMPayment() {
      this.$store.dispatch('auth/payment', this.selectpayment).then(
        () => {
          localStorage.setItem('payment', JSON.stringify(this.selectpayment));
          this.$router.push('/bmpayment')
        })
    },
    MizaPayment() {
      this.$store.dispatch('auth/payment', this.selectpayment).then(
        () => {
          localStorage.setItem('payment', JSON.stringify(this.selectpayment));
          this.$router.push('/Mizapayment')
        })
    },
    checkedAllPayment(event) {
      if (event.target.checked) {
        // this.currenUser.UserIDSerial

        ApplicantService.PostPaymentOrder(this.currenUser.UserIDSerial, 0).then(Response => {
          this.PaymentOrder = Response.data
          this.successful = true;
          return ApplicantService.GetUnpaidPaymentOrderDetails(this.currenUser.UserIDSerial).then(Response => {
            this.OrderDetails = Response.data;
            this.showModal = true;
          })


        }, error => {
          this.seuccess = false
          this.message =
            (error.response && error.response.data && error.response.data.Message) ||
            error.message ||
            error.toString();
        })
      }
    }
  },


  computed: {
    currenUser() {
      return this.$store.state.auth.user
    },
    selectpayment() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.SentPayemtList = this.UnPaidApplicantPaymentsList.filter(x => {
        if (this.SelectedList.includes(x.PaymentID)) {
          return x
        }
      })
    },
    PaymentStore() {
      return this.$store.state.auth.paymentList
    }
  },
  mounted() {
    this.loading = true
    let id = 7;

    axios.get(API_URL + `/HelpPages/SelectHelpPageAndSection?PageId=${id}`)
      .then(response => {
        this.info = response.data
        //console.log(response.data);
      }),
      // eslint-disable-next-line no-unused-vars
      ApplicantDataServices.ApplicantUpdatePaymnet(this.currenUser.UserIDSerial).then(res =>

        this.$store.dispatch('auth/Review', this.reviewApplication + 1)

      ).finally(() => {

        ApplicantDataServices.GetListofApplicantPayments(this.currenUser.UserIDSerial).then(Response => {
          this.AllPayment = Response.data
          this.PaidApplicantPaymentsList = this.AllPayment.filter(x => x.PaymentStatues == "Paid")
          this.UnPaidApplicantPaymentsList = this.AllPayment.filter(x => x.PaymentStatues != "Paid")
          this.loading = false
        }, error => {
          this.loading = false
          this.PaidApplicantPaymentsList = [];
          this.UnPaidApplicantPaymentsList = [];
          this.message =
            (error.response && error.response.data && error.response.data.Message) ||
            error.message ||
            error.toString();
        }).catch(error => {
          this.loading = false
          this.PaidApplicantPaymentsList = []
          this.UnPaidApplicantPaymentsList = []
          this.message = error + 'no data '
        })


      }),
      // eslint-disable-next-line no-unused-vars
      ApplicantDataServices.ApplicantBankMasr_MPGSWalletRetrieveOrder(this.currenUser.UserIDSerial).then(res =>

        this.$store.dispatch('auth/Review', this.reviewApplication + 1)

      ).finally(() => {

        ApplicantDataServices.GetListofApplicantPayments(this.currenUser.UserIDSerial).then(Response => {
          this.AllPayment = Response.data
          this.PaidApplicantPaymentsList = this.AllPayment.filter(x => x.PaymentStatues == "Paid")
          this.UnPaidApplicantPaymentsList = this.AllPayment.filter(x => x.PaymentStatues != "Paid")
          this.loading = false
        }, error => {
          this.loading = false
          this.PaidApplicantPaymentsList = [];
          this.UnPaidApplicantPaymentsList = [];
          this.message =
            (error.response && error.response.data && error.response.data.Message) ||
            error.message ||
            error.toString();
        }).catch(error => {
          this.loading = false
          this.PaidApplicantPaymentsList = []
          this.UnPaidApplicantPaymentsList = []
          this.message = error + 'no data '
        })


      })
    // eslint-disable-next-line no-unused-vars
    ApplicantDataServices.ApplicantBankMasr_UPGSWalletRetrieveOrder(this.currenUser.UserIDSerial).then(res =>

      this.$store.dispatch('auth/Review', this.reviewApplication + 1)

    ).finally(() => {

      ApplicantDataServices.GetListofApplicantPayments(this.currenUser.UserIDSerial).then(Response => {
        this.AllPayment = Response.data
        this.PaidApplicantPaymentsList = this.AllPayment.filter(x => x.PaymentStatues == "Paid")
        this.UnPaidApplicantPaymentsList = this.AllPayment.filter(x => x.PaymentStatues != "Paid")
        this.loading = false
      }, error => {
        this.loading = false
        this.PaidApplicantPaymentsList = [];
        this.UnPaidApplicantPaymentsList = [];
        this.message =
          (error.response && error.response.data && error.response.data.Message) ||
          error.message ||
          error.toString();
      }).catch(error => {
        this.loading = false
        this.PaidApplicantPaymentsList = []
        this.UnPaidApplicantPaymentsList = []
        this.message = error + 'no data '
      })


    })
  },

}
</script>


<style scoped>
@import url('https://maxcdn.bootstrapcdn.com/font-awesome/4.3.0/css/font-awesome.min.css');

h1 {
  color: #285475;
  font-size: 25px;
  border-bottom: 1px #646464 dashed;
  padding: 10px 0px;
}

h1 a {
  color: #50BD77;
}

.card-header {
  padding: .35rem 1.25rem;
  margin-bottom: 0;
  background-color: rgba(0, 0, 0, .03);
  border-bottom: 1px solid rgba(0, 0, 0, .125);
  border-left: 3px solid #EDBD88;
}

.card-header:active {

  border-left: 3px solid #91DC5A;
  width: 100%;
  height: 100%;
  margin: 0px;
}

.card-header h2 [data-toggle="collapse"]:before {
  font-family: FontAwesome;
  content: "\f058";
  display: inline-block;
  padding-right: 11px;
  vertical-align: middle;
  font-weight: 900;
  color: #91DC5A;
  aria-expanded: true
}

.card-header h2 [data-toggle="collapse"].collapsed:before {
  font-family: FontAwesome;
  content: "\f058";
  display: inline-block;
  padding-right: 11px;
  vertical-align: middle;
  font-weight: 900;
  color: #E6E6E6;

}

.card {
  margin-bottom: 20px;
}

.btn-link {
  font-weight: 700;
  color: #285475;
  text-decoration: none;
  font-size: 20px;
  text-decoration: none;

}

.btn-link a {
  text-decoration: none;
}

.card-text {
  border-bottom: 1px #333 dotted;
  padding: 0px 0px;
}

.card-text:last-child {
  border-bottom: none;
  padding: 0px 0px;
}

.card-text span {
  color: #ff8600;
  text-size-adjust: auto;
}

p {
  margin-top: 0;
  margin-bottom: 0.5rem;
}

.panal {
  background: #eee;
  border-radius: 10px;
  color: #333;
  padding: 0px 0px 20px 0px;
  margin: 10px 0;
  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  margin-bottom: 20px !important;


}

.panal-header {
  background: #285475;
  color: #FFFFFF;
  text-align: left;
  border-radius: 10px 0px 0px 0px;
  padding: 10px 20px;
  font-size: 17px;
  font-weight: bold;
  width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}

.panal-body {
  padding: 20px;
  color: #333;
}

.su-border {
  border-color: #3D8FE3 !important;
  background: #F1F9FF !important;
}

.heading {

  font-size: 25px;
  border-bottom: 1px dotted #d4cccc;
  padding: 15px 0px;
  margin: 10px 0px;

}
</style>